export const AUTH_TOKEN = 'ITRADE_DEALER_AUTH_TOKEN';
